// extracted by mini-css-extract-plugin
module.exports = {"column":"account_column__pTO-m","avatar":"account_avatar__3Y_dj","box":"account_box__I6Uwd"};